export const TABLE_DENSITIES = ['large', 'medium', 'small'] as const

export type TableDensity = (typeof TABLE_DENSITIES)[number]

export const DEFAULT_TABLE_DENSITY: TableDensity = 'large'

interface TableDensityStyle {
  /**
   * Minimum row height (a table `<tr>` treats `height` as a floor and grows to
   * fit). Kept low enough that a single-line row auto-fits instead of stranding
   * dead space below it, while a two-line row still grows past it naturally.
   */
  rowHeight: string
  /** Vertical padding on each body cell (overrides the base `p-2.5`). */
  cellPaddingY: string
}

/**
 * Tailwind classes per density. Rows auto-fit their content; these values only
 * set the floor + padding. At `large` a one-line row lands at 48px and a
 * two-line row at 76px — matching the hand-tuned heights tables used before the
 * density control existed, so the default look is unchanged.
 */
// Each floor equals one line of content (the `h-7`/28px line block) plus that
// density's vertical padding, so a single-line row has zero dead space and its
// content reads as centered: large 28+20=48, medium 28+12=40, small 28+8=36.
export const TABLE_DENSITY_STYLES: Record<TableDensity, TableDensityStyle> = {
  large: { rowHeight: 'h-12', cellPaddingY: 'py-2.5' },
  medium: { rowHeight: 'h-10', cellPaddingY: 'py-1.5' },
  small: { rowHeight: 'h-9', cellPaddingY: 'py-1' },
}
